import { render, staticRenderFns } from "./Statement-notification-search.vue?vue&type=template&id=236b6eb7&scoped=true"
import script from "./Statement-notification-search.vue?vue&type=script&lang=js"
export * from "./Statement-notification-search.vue?vue&type=script&lang=js"
import style0 from "./Statement-notification-search.vue?vue&type=style&index=0&id=236b6eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b6eb7",
  null
  
)

export default component.exports